<!--
* @description  IM组件
* @fileName  index
* @author userName
* @date 2024-05-16 10:51:48
!-->
<template>
  <div id="index" class="index">
    <Model @close="close">
      <template v-slot:info>
        <div ref="list" class="message-wrapper">
          <ul>
            <li v-for="(item,i) in list" :key="i" class="message-item">
              <div v-if="i%5==0" :class="{'time':item.dateTime}"><span>{{ item.dateTime }}</span></div>
              <div class="main" :class="{ self: item.userId==userInfo.userId}">
                <div class="content">
                  <div v-if="item.messageType=='text'" class="text" v-html="item.message" />
                  <el-image
                    v-if="item.messageType=='image' && item.message.path"
                    :src="define.comUrl+item.message.path"
                    class="chatList__msg--img"
                    :preview-src-list="[define.comUrl+item.message.path]"
                    :z-index="10000"
                  />
                  <div v-if="item.messageType=='price'" class="text">
                    <span class="text-tip">Hello ,Regarding DTMS's pricing option as
                      below:</span>
                    <div class="baseInfo">
                      <div>
                        <span class="b-title">Origin：</span>
                        <span class="b-content">
                          {{ getOriginType(item.message.inputData.OriginType) }}
                          | {{ item.message.inputData.OriginAddressCode }},
                          {{ item.message.inputData.OriginCountryCode }},
                          {{ item.message.inputData.OriginZipCode }}</span> ｜
                        <span class="b-title">Destination：</span>
                        <span class="b-content">
                          {{ getDestType(item.message.inputData.DestinationType) }}
                          |
                          {{ item.message.data.businessType==3?"#":'' }}{{ item.message.inputData.DestinationAddressCode }}
                          -
                          {{ item.message.data.destinationZipcode }},
                          {{ item.message.data.destinationName }}</span>
                      </div>
                      <div>
                        <span class="b-title">Load：</span>
                        <span class="b-content">{{ item.message.inputData.TotalQuantity }} Unit
                          | Total: {{ item.message.inputData.TotalVolume }} cbm,
                          {{ item.message.inputData.TotalWeight }} kg</span> ｜
                        <span class="b-title">Goods： </span>
                        <span class="b-content">${{ item.message.inputData.GoodsValue }} |
                          {{ item.message.inputData.GoodsName }} |
                          {{ getReadyType(item.message.inputData.GoodsReadyType) }}</span>
                      </div>
                    </div>
                    <div class="priceInfo">
                      <div class="p-left">
                        <!-- <button>Best value</button> -->
                        <div class="p-text">
                          <img
                            :src="require('@/assets/img/client/check/'+getMode(item.message.data.businessType)+'.png')"
                            width="16px"
                            height="16px"
                          >
                          <span class="ml8">{{ getMode(item.message.data.businessType) }} |
                            Est.{{ item.message.data.workDays }} days</span>
                        </div>
                        <div v-if="item.message.data.businessType==1" class="p-text">
                          <img
                            src="../../../assets/img/client/chat/address.png"
                            width="16px"
                            height="16px"
                          >
                          <span
                            class="ml8"
                          >{{ item.message.data.originZipcode }}，{{ item.message.data.originName }}</span>
                          <span class="p-line" />
                          <img
                            src="@/assets/img/client/check/Express.png"
                            width="16px"
                            height="16px"
                          >
                          <span class="p-line" />
                          <img
                            src="@/assets/img/client/chat/address.png"
                            width="16px"
                            height="16px"
                          >
                          <span
                            class="ml8"
                          >{{ item.message.inputData.DestinationZipCode }}，{{ item.message.data.destinationName }}</span>
                        </div>
                        <div v-if="item.message.data.businessType==2" class="p-text">
                          <img
                            src="@/assets/img/client/chat/address.png"
                            width="16px"
                            height="16px"
                          >
                          <span
                            class="ml8"
                          >{{ item.message.data.originZipcode }}，{{ item.message.data.originName }}</span>
                          <span class="p-line" />
                          <img
                            src="@/assets/img/client/check/Express.png"
                            width="16px"
                            height="16px"
                          >
                          <span class="p-line" />
                          <span class="ml8">{{ item.message.data.startPortCode }}</span>
                          <span class="p-line" />
                          <img
                            src="@/assets/img/client/check/Air.png"
                            width="16px"
                            height="16px"
                          >
                          <span class="p-line" />
                          <span class="ml8">{{ item.message.data.destPortCode }}</span>
                          <span class="p-line" />
                          <img
                            src="@/assets/img/client/chat/car.png"
                            width="16px"
                            height="16px"
                          >
                          <span class="p-line" />
                          <img
                            src="@/assets/img/client/chat/address.png"
                            width="16px"
                            height="16px"
                          >
                          <span
                            class="ml8"
                          >{{ item.message.data.destinationZipcode }},{{ item.message.data.destinationName }}</span>
                        </div>
                        <div v-if="item.message.data.businessType==3" class="p-text">
                          <img
                            src="@/assets/img/client/chat/address.png"
                            width="16px"
                            height="16px"
                          >
                          <span
                            class="ml8"
                          >{{ item.message.data.originZipcode }}，{{ item.message.data.originName }}</span>
                          <span class="p-line" />
                          <img
                            src="@/assets/img/client/check/Ocean.png"
                            width="16px"
                            height="16px"
                          >
                          <span class="p-plus">+</span>
                          <img
                            src="@/assets/img/client/chat/car.png"
                            width="16px"
                            height="16px"
                          >
                          <span class="p-line" />
                          <img
                            src="@/assets/img/client/chat/address.png"
                            width="16px"
                            height="16px"
                          >
                          <span
                            class="ml8"
                          >#{{ item.message.inputData.FbaWarehouseCode }}，{{ item.message.data.destinationName }}</span>
                        </div>
                        <div v-if="item.message.data.businessType==4" class="p-text">
                          <img
                            src="@/assets/img/client/chat/address.png"
                            width="16px"
                            height="16px"
                          >
                          <span class="ml8">{{ item.message.data.originName }}</span>
                          <span class="p-line" />
                          <img
                            src="@/assets/img/client/check/Express.png"
                            width="16px"
                            height="16px"
                          >
                          <span class="p-line" />
                          <span class="ml8">{{ item.message.data.startPortCode }}</span>
                          <span class="p-line" />
                          <img
                            src="@/assets/img/client/check/Ocean.png"
                            width="16px"
                            height="16px"
                          >
                          <span class="p-line" />
                          <span class="ml8">{{ item.message.data.destPortCode }}</span>
                          <span class="p-line" />
                          <img
                            src="@/assets/img/client/chat/car.png"
                            width="16px"
                            height="16px"
                          >
                          <span class="p-line" />
                          <img
                            src="@/assets/img/client/chat/address.png"
                            width="16px"
                            height="16px"
                          >
                          <span class="ml8">{{ item.message.data.destinationName }}</span>
                        </div>
                      </div>
                      <div class="line" />
                      <div class="p-right">
                        <div><span class="p-text-1">US
                          ${{ item.message.data.totalAmount }}</span>
                          <!-- <span class="p-text-2">61</span> -->
                        </div>
                        <div><span class="p-text-3">Rate expires</span>
                        </div>
                        <div><span
                          class="p-text-4"
                        >{{ item.message.data.expirationTime }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </template>
      <template v-slot:btn>
        <div class="tool">
          <img src="@/assets/img/client/chat/picture.png" width="21px" height="21px">
        </div>
        <div class="send">
          <textarea ref="text" v-model="content" placeholder="输入聊天内容" @keyup="onKeyup" />
          <div class="send-btn" @click="send">
            <img src="@/assets/img/client/chat/fabu@2x.png" width="14px" height="14px">
            <span>发送</span>
          </div>
        </div>
      </template>
    </Model>
  </div>
</template>

<script>
import emojiList from 'static/emoji.json'
import Model from './model.vue'
import ReconnectingWebSocket from 'reconnecting-websocket'
// import { getCookie } from '@/utils/cookiejs'
import { getToken, getUser } from '@/utils/auth'
import {
  getCookie
} from '@/utils/cookiejs'
const heartCheck = {
  // 100秒发一次心跳，比server端设置的连接时间稍微小一点；
  // 在接近断开的情况下以通信的方式去重置连接时间；
  timeout: 100000,
  serverTimeoutObj: null
}
export default {
  name: 'Index',
  components: {
    // 组件的引用
    Model
  },
  props: {
    // 父辈向子辈传参
  },
  data() {
    return {
      content: '',
      selectedChat: [
        {
          date: '16:19',
          content: 'Hello, how can we help you?',
          self: false,
          pricing: false
        },
        {
          date: '',
          content: '',
          self: true,
          pricing: true
        },
        {
          date: '',
          content: 'Hello, how can we help you?',
          self: true,
          pricing: false
        }
      ],
      socket: null,
      data: {},
      inputData: {},
      token: '',
      toUserId: '',
      showHistory: false,
      list: [],
      emojiList: emojiList,
      userInfo: {},
      visible: false
    }
  },
  computed: {
    // 计算属性
  },
  watch: {
    // 监测变化
  },
  created() {
    this.token = getCookie('token')
    this.userInfo = getUser() || {}
    console.log(this.userInfo)
  },
  mounted() {
    // 页面进入时加载内容

  },
  methods: {
    getMode(type) {
      switch (type) {
        case 1:
          return 'Express'
        case 2:
          return 'Air'
        case 3:
          return 'Ocean'
        case 4:
          return 'Ocean'
      }
    },
    getOriginType(type) {
      switch (type) {
        case 1:
          return 'Port/Aiport'
        case 2:
          return 'Factory/Warehouse'
        case 3:
          return 'Business address'
        case 4:
          return 'Residential address'
      }
    },
    getDestType(type) {
      switch (type) {
        case 1:
          return 'Port/Aiport'
        case 2:
          return 'Warehouse'
        case 3:
          return 'Amazon fulfillment center'
        case 4:
          return 'Business address'
        case 5:
          return 'Residential address'
      }
    },
    getReadyType(type) {
      switch (type) {
        case 1:
          return 'Goods are ready'
        case 2:
          return 'Within 2 weeks'
        case 3:
          return 'More than 2 weeks'
      }
    },
    close() {
      this.$emit('close')
    },
    init(inputData, data, toUserId) {
      this.data = data
      this.inputData = inputData
      this.toUserId = toUserId
      this.visible = true
      this.initWebSocket()
      var that = this
      setTimeout(function() {
        // 获取消息列表
        var messageList = {
          method: 'MessageList',
          toUserId: toUserId,
          formUserId: that.userInfo.id,
          token: that.token,
          currentPage: 1,
          pageSize: 30,
          sord: 'desc'
        }
        console.log(messageList)
        that.socket.send(JSON.stringify(messageList))
        if (inputData) {
          var priceMessage = {
            method: 'SendMessage',
            toUserId: that.toUserId,
            messageType: 'price',
            messageContent: JSON.stringify({
              inputData: inputData,
              data: data
            }),
            token: that.token
          }
          that.socket.send(JSON.stringify(priceMessage))
        }
      }, 1000)
    },
    getList(data) {
      const list = []
      for (let i = 0; i < data.list.length; i++) {
        const item = data.list[i]
        if (item.contentType === 'text') {
          item.content = this.replaceEmoji(item.content)
        } else if (item.contentType === 'image') {
          item.content = JSON.parse(item.content)
        } else {
          item.content = JSON.parse(item.content)
        }
        list.push({
          userId: item.sendUserId,
          messageType: item.contentType,
          message: item.content,
          dateTime: this.xms.toDate(item.sendTime)
        })
      }
      this.list = list
    },
    replaceEmoji(str) {
      // 替换表情符号为图片
      const replacedStr = str.replace(/\[([^(\]|\[)]*)\]/g, (item, index) => {
        let obj = ''
        for (let i = 0; i < this.emojiList.length; i++) {
          const row = this.emojiList[i]
          if (row.alt == item) {
            const url = require(`static/emoji/${row.url}`)
            obj = `<img src="${url}" class="chatList-text-emoji" />`
            break
          }
        }
        return obj
      })
      str = replacedStr
      return str
    },
    // 方法
    initWebSocket() {
      this.socket = this.$store.getters.socket || null
      if ('WebSocket' in window) {
        if (!this.socket) {
          this.socket = new ReconnectingWebSocket(this.define.WebSocketUrl)
          this.$store.commit('user/SET_SOCKET', this.socket)
        }
        // 添加事件监听
        const socket = this.socket
        socket.onopen = () => {
          var onConnection = {
            'method': 'OnConnection',
            'token': this.token,
            'mobileDevice': false
          }
          socket.send(JSON.stringify(onConnection))
        }
        socket.onmessage = (event) => {
          console.log(event.data)
          const data = JSON.parse(event.data)
          this.resetCheck()
          if (data.method == 'initMessage') {
            // this.messageCount = data.unreadMessageCount + data.unreadNoticeCount
            // this.isTwinkle = !!data.unreadNums.length
          }
          // 用户在线
          if (data.method == 'Online') {}
          // 用户离线
          if (data.method == 'Offline') {}
          // 消息推送（消息公告用的）
          if (data.method == 'messagePush') {
            // this.messageCount += data.unreadNoticeCount
            // if (this.$refs.MessageList.visible) this.$refs.MessageList.init()
          }
          // 用户过期
          if (data.method == 'logout') {
            if (this.socket) {
              this.socket.close()
              this.socket = null
              this.$store.commit('user/SET_SOCKET', this.socket)
            }
            clearInterval(heartCheck.serverTimeoutObj)
            heartCheck.serverTimeoutObj = null
          }
          // 断开websocket连接
          if (data.method == 'closeSocket') {
            if (this.socket) {
              this.socket.close()
              this.socket = null
              this.$store.commit('user/SET_SOCKET', this.socket)
            }
            clearInterval(heartCheck.serverTimeoutObj)
            heartCheck.serverTimeoutObj = null
          }
          // 接收对方发送的消息
          if (data.method == 'receiveMessage') {
            if (data.formUserId == this.toUserId) {
              const messItem = {
                userId: data.formUserId,
                messageType: data.messageType,
                message: data.formMessage,
                dateTime: this.xms.toDate(data.dateTime)
              }
              if (messItem.messageType === 'text') {
                messItem.message = this.replaceEmoji(messItem.message)
              }
              this.list.push(messItem)
            }
          }
          // 显示自己发送的消息
          if (data.method == 'sendMessage') {
            if (this.toUserId !== data.toUserId) return
            // 添加到客户端
            const messItem = {
              userId: data.UserId,
              messageType: data.messageType,
              message: data.toMessage,
              dateTime: this.xms.toDate(data.dateTime)
            }
            this.list.push(messItem)
          }
          // 消息列表
          if (data.method == 'messageList') {
            this.getList(data)
          }
        }
        socket.onclose = () => {
          clearInterval(heartCheck.serverTimeoutObj)
          heartCheck.serverTimeoutObj = null
        }
      }
    },
    resetCheck() {
      clearInterval(heartCheck.serverTimeoutObj)
      heartCheck.serverTimeoutObj = null
      this.start()
    },
    start() {
      heartCheck.serverTimeoutObj = setInterval(() => {
        if (this.socket) {
          const message = {
            method: 'heartCheck',
            token: this.$store.getters.token
          }
          this.socket.send(JSON.stringify(message))
          this.resetCheck()
        }
      }, heartCheck.timeout)
    },
    // 按回车发送信息
    onKeyup(e) {
      if (e.keyCode === 13) {
        this.send()
      }
    },
    send() {
      if (!this.content) {
        return
      }
      const socket = this.socket
      const sendMessage = {
        method: 'SendMessage',
        toUserId: this.toUserId,
        messageType: 'text',
        messageContent: this.content,
        token: this.token
      }
      socket.send(JSON.stringify(sendMessage))
      this.content = ''
    },
    closeDialog() {
      this.$store.commit('user/CHAT_VISIBLE', false)
    },
    replaceFace(con) {
      // if(con.includes('/:')) {
      //         con = con.replace('', '<img src="static/emoji/"  alt="" style="vertical-align: middle; width: 24px; height: 24px" />');
      //     return con;
      // }
      return con
    }
  }
}
</script>
<style scoped lang='scss'>
	@font-face {
		font-family: "D-DINExp";
		src: url("../../../assets/font/D-DINExp.otf") format('opentype');
	}

	ul,
	li {
		margin: 0;
		padding: 0;
		border: 0;
		font-size: 100%;
		font-weight: normal;
		vertical-align: baseline;
		list-style-type: none;
	}

	textarea::-webkit-input-placeholder {
		font-family: PingFangSC, PingFang SC;
		font-weight: 400;
		font-size: 13px;
		color: #AAAAAA;
	}

	/* 使用webkit内核的浏览器 */
	textarea:-moz-placeholder {
		font-family: PingFangSC, PingFang SC;
		font-weight: 400;
		font-size: 13px;
		color: #AAAAAA;
	}

	/* Firefox版本4-18 */
	textarea::-moz-placeholder {
		font-family: PingFangSC, PingFang SC;
		font-weight: 400;
		font-size: 13px;
		color: #AAAAAA;
	}

	/* Firefox版本19+ */
	textarea:-ms-input-placeholder {
		font-family: PingFangSC, PingFang SC;
		font-weight: 400;
		font-size: 13px;
		color: #AAAAAA;
	}

	/* IE浏览器 */

	.message-wrapper {
		// min-height: 390px;
		// max-height: 390px;
		padding: 10px 24px;
		box-sizing: border-box;
		overflow-y: auto;

		.message-item {
			margin-bottom: 15px;
			display: flow-root;
		}

		.time {
			width: 100%;
			font-size: 12px;
			margin: 7px auto;
			text-align: center;

			span {
				display: inline-block;
				padding: 2px 12px;
				border-radius: 12px;
				background: rgba(0, 0, 0, 0.04);
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 12px;
				color: #333333;
			}
		}

		.main {
			.content {
				float: left;
				display: inline-block;
				//margin-left: 10px;
				position: relative;
				padding: 8px 10px;
				// max-width: 330px;
				// min-height: 36px;
				line-height: 24px;
				box-sizing: border-box;
				font-size: 14px;
				text-align: left;
				word-break: break-all;
				background: #FFFFFF;
				border-radius: 0px 16px 16px 16px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				font-size: 13px;
				color: #333333;
				// &:before{
				//     content: " ";
				//     position: absolute;
				//     top: 12px;
				//     right: 100%;
				//     border: 6px solid transparent;
				//     border-right-color: #fafafa;
				// }

			}

			.chatList__msg--img {
				position: relative;
				max-width: 200px;
				width: 100%;
				margin: 10px 0;
				overflow: hidden;
				border-radius: 5px;
				cursor: pointer;
				display: block;
			}
		}

		.self {
			text-align: right;

			.content {
				float: right;
				background: #447CFF;
				border-radius: 16px 0px 16px 16px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				font-size: 13px;
				color: #FFFFFF;

				.text {
					.text-tip {
						font-family: PingFangSC, PingFang SC;
						font-weight: 500;
						font-size: 13px;
						color: #FFFFFF;
					}

					.chatList__msg--img {
						position: relative;
						max-width: 200px;
						width: 100%;
						margin: 10px 0;
						overflow: hidden;
						border-radius: 5px;
						cursor: pointer;
						display: block;
					}

					.baseInfo {
						width: 823px;
						height: 52px;
						background: rgba(255, 255, 255, 0.96) !important;
						border-radius: 8px;
						font-family: PingFangSC, PingFang SC;
						font-size: 13px;
						color: #333333;
						margin-top: 8px;
						padding: 8px 16px;

						.b-title {
							font-weight: 550;
						}

						.b-content {
							font-weight: 500;
						}
					}

					.priceInfo {
						width: 823px;
						height: 96px;
						background: rgba(255, 255, 255, 0.96);
						border-radius: 8px;
						padding: 8px 16px;
						display: flex;
						align-items: center;
						justify-content: space-between;
						margin-top: 8px;

						.p-left {
							width: 624px;

							button {
								width: 88px;
								height: 25px;
								background: rgba(2, 127, 252, 0.08);
								border-radius: 13px;
								font-family: PingFangSC, PingFang SC;
								font-weight: 500;
								font-size: 13px;
								color: #027FFC;
								border: 0;
							}

							.p-text {
								font-family: D-DINExp;
								font-weight: normal;
								font-size: 14px;
								color: #333333;
								display: flex;
								align-items: center;
								line-height: 28px;

								.ml8 {
									margin-left: 8px;
								}

								.p-line {
									width: 16px;
									height: 1px;
									background: #AAAAAA;
									display: block;
									margin: 0 8px;
								}

								.p-plus {
									color: #AAAAAA;
									display: block;
									margin: 0 8px;
								}
							}
						}

						.line {
							width: 1px;
							height: 88px;
							background: #DDDDDD;
						}

						.p-right {
							text-align: center;

							.p-text-1 {
								font-family: D-DINExp, D-DINExp;
								font-weight: bold;
								font-size: 18px;
								color: #333333;
							}

							.p-text-2 {
								font-family: D-DINExp;
								font-weight: normal;
								font-size: 12px;
								color: #333333;
								position: relative;
								top: -5px;
							}

							.p-text-3 {
								font-family: D-DINExp;
								font-weight: normal;
								font-size: 13px;
								color: #AAAAAA;
								margin-right: 8px;
							}

							.p-text-4 {
								font-family: D-DINExp;
								font-weight: normal;
								font-size: 13px;
								color: #333333;
							}
						}
					}
				}
			}

		}

	}

	.tool {
		height: 40px;
		margin-left: 24px;
		display: flex;
		align-items: center;
	}

	.send {
		margin: 0 24px;
		height: 72px;

		textarea {
			width: 922px;
			height: 72px;
			background: rgba(255, 255, 255, 0);
			border: 0;
			resize: none;
			box-sizing: border-box;
			padding: 0;
		}

		textarea:focus {
			outline: none !important;
			border-color: #FFFFFF;
			box-shadow: 0 0 10px #FFFFFF;

		}

		.send-btn {
			width: 80px;
			height: 32px;
			background: #3370ff;
			border-radius: 8px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 600;
			font-size: 13px;
			color: #FFFFFF;
			display: flex;
			align-items: center;
			justify-content: center;
			cursor: pointer;
			position: relative;
			top: -36px;
			float: right;

			img {
				margin-right: 6px;
			}
		}
	}
</style>
